<template>
  <div class="block-banners">
    <img src="/static/img/recommend/lp/kurenotori/products/bnr_kurenotori_menu_list.png" @click="onBannerClick('kure')">
    <img src="/static/img/recommend/lp/kurenotori/products/bnr_kanoucoco_10year_chronology.png" @click="onBannerClick('coco')">
    <span class="dokomade" @click="onBannerClick('deluxe')">
        <img src="/static/img/recommend/lp/kurenotori/products/bnr_dokomade_20220726.png" alt="">
        <span class="caption">【特別鑑定】人気急上昇の占い師たちが、あなたの恋を徹底鑑定！</span>
        <span class="price">￥888円（税込）→￥0（会員特典）</span>
      </span>
  </div>
</template>

<script>
export default {
  name: 'BannerBlock',
  methods: {
    onBannerClick(val){
      // console.log('バナー[%s]クリック', val)
      switch (val) {
        case 'kure':
          location.href = '/tag/444'
          break
        case 'coco':
          location.href = '/products/87/0001/result'
          break
        case 'deluxe':
          location.href = '/deluxe/lp/1'
          break
      }
    }
  },
}
</script>

<style scoped lang="scss">
.block-banners {
  background: white;
  padding: 40px 20px 65px;
  img{
    margin-bottom: 20px;
  }
}
.caption{
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #32373F;
  margin-top: -10px;
  display: block;
}
.price{
  color: #fe7397;
  font-weight: 600;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Products/kurenotori/partials/BannerBlock.vue